<div *ngIf="!(!isFree && isPremium && productDetails)" class="main-content-wrap">
    <h1 class="pageTitle">Sample Report of Paytm - {{productDetails?.NAME}}</h1>
    <app-iframe-scaler [src]="pdfSampleURL"></app-iframe-scaler>
</div>
<br>
<app-subscribe-form-component *ngIf="!(!isFree && isPremium)"></app-subscribe-form-component>
<app-industry-report-action-component *ngIf="deviceType == 'mobile'"></app-industry-report-action-component>

